import React from "react";
import GoogleMapReact from "google-map-react";
import BrandLogo from "../../images/logo.svg";
import $ from "jquery"
import { Link } from "gatsby";
import { useLocation } from "@reach/router"

const EmptyMarker = () => <></>;

const Marker = (props) => 
    <div className="position-relative">
        <img src={BrandLogo} onClick={props.onClick}/>
    </div>;
;

const GoogleMap = (props) => {
    const location = useLocation();
    const [selected, setSelected] = React.useState(null);
    if(!props.lat || isNaN(props.lat)) {
        return null;
    }
    return (
        <div className="w-100 h-100">
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: process.env.GATSBY_GOOGLE_MAP_KEY
                }}
                defaultCenter={{
                    lat: props.lat,
                    lng: props.lng
                }}
                defaultZoom={15}
            >
                {props?.data?.length > 0 && props.data.map((each, i) =>
                    <Marker
                        key={i}
                        lat={each.lat}
                        lng={each.lng}
                        onClick={async() => {
                            await setSelected(null)
                            await setSelected(each)
                        }}
                    />
                )}
                {props?.singleMap == true &&
                    <Marker
                        lat={props.lat}
                        lng={props.lng}
                        onClick={async() => {
                            await setSelected(null)
                            await setSelected(props.data)
                        }}
                    />
                }
                {props?.data?.length == 0 && <EmptyMarker
                    lat={props.lat}
                    lng={props.lng}
                />}
                {selected != null && 
                    <div className="card" lat={selected.lat} lng={selected.lng}  style={{ width: 320 }}>
                        <img src={selected?.image?.url} className="card-img-top"/>
                        <div className="card-body p-3">
                            <h5 class="card-title mb-0">
                                <Link to={selected.Url ? (`/local-living/garden-squares/${selected.Url}/`) : location.pathname}>
                                    {selected?.Title}
                                </Link>
                            </h5>
                        </div>
                    </div>
                }
            </GoogleMapReact>
        </div>
    )
}

export default GoogleMap;